"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var clsx_1 = __importDefault(require("clsx"));
var i18next_1 = __importDefault(require("i18next"));
var react_i18next_1 = require("react-i18next");
var _1 = require(".");
require("./LayoutMenu.scss");
require("./LayoutNavLinkGroup.scss");
exports.LayoutNavLinkGroup = function (props) {
    var t = react_i18next_1.useTranslation(['menu']).t;
    var opened = props.opened, mainMenuExpend = props.mainMenuExpend, children = props.children;
    var _a = react_1.useState(!!opened), isOpen = _a[0], setIsOpen = _a[1];
    var item = props.item;
    var disabled = props.disabled;
    var onNavLinkClicked = react_1.useCallback(function () {
        setIsOpen(!isOpen);
    }, [isOpen]);
    var directionClass = i18next_1.default.language === 'ar' ? 'closedRtl' : 'closed';
    return (react_1.default.createElement("div", { className: "eta-NavLinkGroup" },
        react_1.default.createElement(react_router_dom_1.NavLink, { key: item.id, id: item.id, title: t(item.title), to: { pathname: item.pathname }, className: clsx_1.default('layout-menu-nav-item', disabled && 'layout-menu-nav-item--disabled'), activeClassName: "layout-menu-nav-item--active", onClick: function (ev) { return (disabled ? ev.preventDefault() : onNavLinkClicked()); }, isActive: function () { return false; } },
            react_1.default.createElement(_1.LayoutMenuIcon, { className: clsx_1.default('layout-menu-nav-item-icon', isOpen ? 'open' : directionClass), iconName: "ChevronDown", showBadge: false }),
            react_1.default.createElement("div", { className: "layout-menu-nav-item-label" }, t(item.title))),
        isOpen && (react_1.default.createElement("div", { className: mainMenuExpend ? 'childPlacholder' : 'childPlacholderCollapsed' }, children))));
};
//# sourceMappingURL=LayoutNavLinkGroup.js.map